import { AuthService } from "@js/services/AuthService";
import { CaseService } from "@js/services/CaseService";
import { RoleService } from "@js/services/RoleService";
import {
  ApplicationUser,
  AppPackagePricing,
  Case,
  CaseClient,
  HubspotContactRequest,
  PaymentClient,
  PricingFrequencyEnum,
  ProductTypeEnum,
  StaticDataClient,
  UserClient,
  UserRoleEnum,
} from "@src/apis/ModularClient";
import { ModuleAppFeatureDTO } from "@js/DTO/ModuleAppFeatureDTO.cs";

export class PaymentController {
  caseId: number;
  case: Case;
  disablepayment: boolean = false;
  message: string = "";
  modal: boolean = false;
  isLoggedInUser: boolean = false;
  user: ApplicationUser;

  appPackagePrices: AppPackagePricing[];
  selectedProduct: AppPackagePricing = null;
  selectedProductList: AppPackagePricing[] = [];
  productCode: string;
  isSelected: boolean = false;
  moduleAppFeatures: ModuleAppFeatureDTO[];
  moduleFeatureCount: number = 0;
  selecteFeatureCount: number = 0;
  isBroker: boolean = false;
  isBorrower: boolean = false;
  billingFrequency: Array<{ id: number; value: string }> = [
    { id: 1, value: "Monthly" },
    { id: 2, value: "Yearly" },
  ];
  selectedPricingFrequency: boolean = false;
  selectedPricingFrequencyEnum: PricingFrequencyEnum;
  isQuickSearchSelected: boolean = false;
  isBookCallSelected: boolean = false;
  infoPanelSubheading: string;
  infoPanelHeading: string;
  panelHeaderText: string;
  orderButtonText: string = "Continue";
  orderButtonDisabled: boolean = false;
  showOrderButton: boolean = true;
  totalAmountToPay: number = 0;
  isAddOnSelected: boolean = false;
  whitelabelPrice: number = 0;
  leadGeneratorName: string;

  static $inject = [
    "$routeParams",
    "$scope",
    "$rootScope",
    "$location",
    "PaymentClient",
    "CaseService",
    "CaseClient",
    "RoleService",
    "$cookies",
    "AuthService",
    "UserClient",
    "StaticDataClient",
  ];

  constructor(
    private $routeParams: ng.route.IRouteParamsService,
    private $scope: ng.IScope,
    public $rootScope: ng.IRootScopeService,
    private $location: ng.ILocationService,
    private paymentClient: PaymentClient,
    private caseService: CaseService,
    private caseClient: CaseClient,
    private roleService: RoleService,
    private $cookies: ng.cookies.ICookiesService,
    private authService: AuthService,
    private userClient: UserClient,
    private staticDataClient: StaticDataClient,
  ) {
    //TODO Change for New pricing
    window.location.assign("https://brickflow.com/pricing");

    this.leadGeneratorName = this.$cookies.get("leadgeneratorname");
    this.isBroker = sessionStorage.getItem("userRole") == "broker";
    this.isBorrower = sessionStorage.getItem("userRole") == "borrower";
    this.user = JSON.parse(sessionStorage.getItem("userDetails"));

    if (
      sessionStorage.getItem("selectedPackage") &&
      sessionStorage.getItem("selectedPackage") != "undefined" &&
      sessionStorage.getItem("selectedPackage") != null
    ) {
      let data = sessionStorage.getItem("selectedPackage");
      this.selectedProduct = JSON.parse(data);
      this.selectedPricingFrequency =
        this.selectedProduct.pricingFrequency == PricingFrequencyEnum.Monthly ? false : true;
      this.getAddOnPrice(this.selectedProduct.pricingFrequency);
    }

    if (sessionStorage.getItem("addAddon")) {
      let data = sessionStorage.getItem("addAddon");
      this.isAddOnSelected = JSON.parse(data);
    }

    if (this.$routeParams.isBroker) {
      this.isBroker = true;
    }
    this.infoPanelHeading =
      this.isBroker == true
        ? "Ready to get started?"
        : "Compare loans from 40+ lenders, in minutes.<br><br>Model deals to check their viability, or contact us to secure the best value loan for your next development.";
    this.infoPanelSubheading =
      this.isBroker == true
        ? "We understand speed and reliable funding are key to retaining your clients. <br>" +
          this.getApplicationName() +
          " for Brokers gives you both."
        : "";
    this.panelHeaderText =
      this.isBroker == true
        ? "Welcome to " + this.getApplicationName() + " for Brokers"
        : "Welcome to " + this.getApplicationName();

    //if ($cookies.get('access_token')) {
    //    this.isLoggedInUser = true;
    //}
    this.getActivePackagePricesForFrequency();

    //this.roleService.GetUserRoles().then((result) => {
    //    if (result.filter(x => x == "Broker").length > 0) {
    //        this.isBroker = true;
    //    }
    //});

    /*  if (this.$routeParams.CaseId && this.$routeParams.CaseId != 'null') {
                  this.caseId = this.$routeParams.CaseId;
                  this.email = this.$routeParams.CaseId;
                  this.caseClient.fetch(this.caseId).then(result => {
                      this.case = result;
  
                  })
              }*/
  }

  getTubeMapValue() {
    return this.caseService.getTubeMap();
  }

  /* makepaymentwithpaypal(caseId: number) {
    this.disablepayment = true;
    this.paymentClient.createPayment(caseId)
      .then((response) => {
        //could be called at c# end at some stage
        window.location.assign(response);
      })
      .catch(() => {
        this.disablepayment = false;
      });
  }*/
  markAsPaid(caseId: number) {
    this.disablepayment = true;
    this.case.isApplicationFeePaid = 1;
    this.case.paid = true;

    this.caseClient.addUpdateReturnOnlyID(this.case).then((response) => {
      this.modal = true;
      this.message = "This case has been marked as paid.";
    });
  }

  backToDashboard(): void {
    this.$location.path("/casedashboard/" + this.caseId);
  }

  getActivePackagePricesForFrequency() {
    this.selectedPricingFrequencyEnum = this.getPriceFrequencyEnum();

    this.paymentClient
      .getActivePackagePricesForFrequency(
        this.selectedPricingFrequencyEnum,
        this.isBroker ? UserRoleEnum.Broker : UserRoleEnum.Client,
      )
      .then((response) => {
        this.appPackagePrices = response;
        if (!sessionStorage.getItem("selectedPackage")) {
          this.selectedProduct = response[0];
        }
      });
  }

  searchNow() {
    (this.$rootScope as any).loanCriteria = null;
    sessionStorage.setItem("selectedPackage", JSON.stringify(this.selectedProduct));
    this.$location.path("/devfinancecriteria");
  }

  signUpNow() {
    sessionStorage.setItem("selectedPackage", JSON.stringify(this.selectedProduct));
    if (this.isBroker) {
      this.$location.path("registerbroker");
    } else {
      this.$location.path("register");
    }
  }

  bookCallNow() {
    this.staticDataClient.getHubspotDeveloperBookMeetingNoSearch().then((hubSpotUrl: string) => {
      window.location.assign(hubSpotUrl);
    });
  }

  getPriceFrequencyEnum(): PricingFrequencyEnum {
    return this.selectedPricingFrequency == false ? PricingFrequencyEnum.Monthly : PricingFrequencyEnum.Yearly;
  }

  convertEnumToString(value) {
    switch (value) {
      case PricingFrequencyEnum.Monthly:
        return "month";
      case PricingFrequencyEnum.Yearly:
        return "year";
      default:
        return "";
    }
  }

  getApplicationName() {
    if (sessionStorage.getItem("applicationName") != null) {
      return sessionStorage.getItem("applicationName");
    } else {
      return "Brickflow";
    }
  }

  /* This will be used when we have multiple products
        onSelectingProduct(selectedProduct) {
            this.selectedProduct = { ...selectedProduct };

            this.isQuickSearchSelected = false;
            this.isBookCallSelected = false;
            if (this.isBroker) {
                if (this.selectedProductList != null && this.selectedProductList.length > 0) {
                    var found = this.selectedProductList.find(function (product) {
                        return product.AppPackageId == selectedProduct.AppPackageId;
                    });

                    if (found) {
                        this.selectedProductList = this.selectedProductList.filter(function (e) { return e.AppPackageId != selectedProduct.AppPackageId });
                    }

                    this.selectedProductList.push(this.selectedProduct);

                } else {
                    this.selectedProductList.push(this.selectedProduct);
                }
            } else {
                this.getModuleQuantityForAppPackage(selectedProduct.AppPackageId);
                this.selectedProductList = []
                this.selectedProductList.push(this.selectedProduct);
            }

            this.isSelected = true;
            this.totalAmountToPay = this.calculateTotal(this.selectedProductList);
        }
      

        isPackageSelected(selectedProduct) {
            if (this.isBroker && selectedProduct && this.selectedProductList.length > 0) {
                var found = this.selectedProductList.find(function (product) {
                    return product.Id == selectedProduct.Id;
                });

                if (found) {
                    return true;
                } else {
                    return false;
                }
            }
        }

        getModuleQuantityForAppPackage(appPackageId: number) {
            this.paymentClient.getModuleQuantityForAppPackage(appPackageId).then((response) => {
                this.moduleFeatureCount = response;
                if (this.moduleFeatureCount > 0) {
                    this.paymentClient.getAllModuleAppFeatures().then((response) => {
                        this.moduleAppFeatures = response;
                    })
                }
            });
        }

        onSelectingModuleFeature(selectedAppFeature) {
            if (!selectedAppFeature.Selected) {
                this.selecteFeatureCount++;
            } else {
                this.selecteFeatureCount--;
            }

            selectedAppFeature.Selected = !selectedAppFeature.Selected;

        }
     
       onSelectingQuickSearch() {
            this.isQuickSearchSelected = !this.isQuickSearchSelected;
            this.removeSelectedProduct();
        }

        onSelectingBookCall() {
            this.isBookCallSelected = !this.isBookCallSelected;
            this.removeSelectedProduct();
        }

        removeSelectedProduct() {
            this.selectedProductList = [];
            this.selectedProduct = null;
            this.isSelected = false;
        }*/

  orderButton() {
    const currentPath = this.$location.path();

    if (currentPath.startsWith("/promo")) {
      let hubspotContactRequest: HubspotContactRequest = {
        user: this.user,
        page: "PACKAGESELECTION",
        login: false,
        orgCode: this.$cookies.get("org_code"),
        role: parseInt(sessionStorage.getItem("userRole")) as UserRoleEnum,
        organisationLinkId: 0,
        productType: ProductTypeEnum.None,
        dealId: null,
        developmentInputWithNoLoginUniqueRef: "",
        clientId: null,
      };
      this.userClient.sendEventToHubspot(hubspotContactRequest);
      sessionStorage.setItem("selectedPackage", JSON.stringify(this.selectedProduct));
      this.$location.path("/addons");
    } else if (currentPath === "/addons") {
      let hubspotContactRequest: HubspotContactRequest = {
        user: this.user,
        page: "ADDONSELECTION",
        login: false,
        orgCode: this.$cookies.get("org_code"),
        role: parseInt(sessionStorage.getItem("userRole")) as UserRoleEnum,
        organisationLinkId: 0,
        productType: ProductTypeEnum.None,
        dealId: null,
        developmentInputWithNoLoginUniqueRef: "",
        clientId: null,
      };
      this.userClient.sendEventToHubspot(hubspotContactRequest);
      this.signUpNow();
    }
  }

  back() {
    const currentPath = this.$location.path();
    if (currentPath.startsWith("/promo")) {
      this.$location.path("/initialregister");
    } else if (currentPath === "/addons") {
      this.$location.path("/promo/" + (this.isBroker ? "true" : ""));
    }
  }

  calculateTotal(): number {
    return (
      Number(this.selectedProduct?.quantity * this.selectedProduct?.priceAmount) +
      Number(this.isAddOnSelected ? this.whitelabelPrice : 0)
    );
  }

  emptyBasket() {
    this.removeAddOn();
    //this.selectedProduct.quantity = 0;
    this.selectedProduct = this.appPackagePrices[0];
    sessionStorage.removeItem("selectedPackage");
  }

  getAddOnPrice(frequency: PricingFrequencyEnum) {
    this.paymentClient.getWhiteLabelPrice(frequency).then((response) => {
      this.whitelabelPrice = Number(response);
    });
  }

  addAddOn() {
    this.isAddOnSelected = true;
    sessionStorage.setItem("addAddon", "true");
  }

  removeAddOn() {
    this.isAddOnSelected = false;
    sessionStorage.setItem("addAddon", "false");
  }

  getContractLengthText(frequency: PricingFrequencyEnum, contractLength: number) {
    if (contractLength == 1) {
      return "1 Year Plan";
    } else if (contractLength == 2) {
      return "2 Year Plan";
    } else {
      return frequency == PricingFrequencyEnum.Monthly ? "Monthly Plan" : "Annual Plan";
    }
  }
}
